import {createReducer} from "redux-act";
import {toggleMenu} from "modules/actions";

const initial = {
	isOpen: false,
};

export const menu = createReducer({}, initial).on(toggleMenu, (state, payload) => ({
	...state,
	isOpen: payload,
}));
